import { ArrowLeft } from 'lucide-react';
import { Button } from '@/components/ui/button';
import type { ModerationDetail } from '../types';
import { formatDateTime } from '../lib/display';
import { PriorityBadge, StatusBadge } from './Badges';

// Detail header (doc 09 §4.2): back · reportId (REP-<id>) · priority + status badges · reported date.
export function DetailHeader({
  report,
  onBack,
}: {
  report: ModerationDetail;
  onBack: () => void;
}) {
  const verb = report.kind === 'FEEDBACK' ? 'Feedbacked' : 'Reported';
  return (
    <div className="flex flex-wrap items-center gap-3">
      <Button variant="secondary" size="icon" onClick={onBack} aria-label="Back">
        <ArrowLeft />
      </Button>
      <div className="min-w-0 flex-1">
        <div className="flex flex-wrap items-center gap-2">
          <h1 className="text-xl font-semibold">{report.reportId}</h1>
          <PriorityBadge priority={report.priority} />
          <StatusBadge status={report.status} />
        </div>
        <p className="text-sm text-muted-foreground">
          {verb} on {formatDateTime(report.reportedDate)}
        </p>
      </div>
    </div>
  );
}
